import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

// ✅ Days of the week mapping
const daysOfWeek = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
const todayIndex = new Date().getDay() === 0 ? 6 : new Date().getDay() - 1; // Adjust Sunday as index 6

// ✅ Styled Components
const StyledContainer = styled(Container)`
  background-color: #000;
  color: #FFFFFF;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

const StreakNumber = styled.div`
  background-color: #FF7C24;
  color: #000;
  font-size: 40px;
  font-weight: bold;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StreakMessage = styled.p`
  font-size: 22px;
  font-weight: bold;
  margin: 10px 0;
`;

const DaysContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
`;

const DayBox = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${({ active }) => (active ? '#2ECC71' : '#555')};
  color: ${({ active }) => (active ? '#fff' : '#000')};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
`;

const DayLabel = styled.div`
  text-align: center;
  font-size: 14px;
  margin-top: 5px;
`;

const InfoBox = styled.div`
  background-color: transparent;
  border: 2px solid #fff;
  padding: 10px 15px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 10px;
  margin-top: 20px;
`;

const WarningBox = styled.div`
  background-color: transparent;
  border: 2px solid red;
  color: red;
  padding: 10px 15px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 10px;
  margin-top: 15px;
`;

const ContinueButton = styled(Button)`
  background-color: #FF7C24;
  border-color: #FF7C24;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;
  padding: 12px 30px;
  width: 100%;
  max-width: 300px;
  margin-top: 30px;
`;

const PostActivationStreakCountPage = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate('/post-activation-streak-commit');
  };

  return (
    <StyledContainer>
      {/* ✅ Streak Number Display */}
      <StreakNumber>1</StreakNumber>

      {/* ✅ Streak Message */}
      <StreakMessage>Day streak!</StreakMessage>

      {/* ✅ Days of the Week with Tick / Cross */}
      <DaysContainer>
        {daysOfWeek.map((day, index) => (
          <div key={index}>
            <DayBox active={index === todayIndex}>{index === todayIndex ? '✔️' : '❌'}</DayBox>
            <DayLabel>{day}</DayLabel>
          </div>
        ))}
      </DaysContainer>

      {/* ✅ Streak Info */}
      <InfoBox>A streak counts how many days you practiced in a row</InfoBox>

      {/* ✅ Warning Message */}
      <WarningBox>miss a practice day, and it resets to 0.</WarningBox>

      {/* ✅ Continue Button */}
      <ContinueButton onClick={handleContinue}>Continue</ContinueButton>
    </StyledContainer>
  );
};

export default PostActivationStreakCountPage;
